(function () {
  'use strict';
  var ruhig = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function starte(wurzel, laufen) {
    if (wurzel.__oau) wurzel.__oau.stopp();
    var buehne = wurzel.querySelector('[data-oau-buehne]');
    var knopf = wurzel.querySelector('[data-oau-knopf]');
    var bilder = Array.prototype.slice.call(wurzel.querySelectorAll('[data-oau-bild]'));
    if (!buehne || bilder.length < 2) return;
    var takt = parseInt(wurzel.getAttribute('data-takt'), 10) || 1000;
    var einmal = wurzel.getAttribute('data-ablauf') === 'einmal', fertig = false;

    bilder.forEach(function (b, i) {
      buehne.insertBefore(b, knopf);
      var img = b.querySelector('img');
      if (!img) return;
      img.loading = 'eager';
      if (i > 0) img.setAttribute('aria-hidden', 'true');
    });

    var jetzt = 0, uhr = null, laeuft = false, sichtbar = false, angehalten = ruhig && !laufen;

    function zeige(i) {
      jetzt = i % bilder.length;
      bilder.forEach(function (b, k) { b.classList.toggle('is-an', k === jetzt); });
      wurzel.dispatchEvent(new CustomEvent('oau:bild', { detail: jetzt, bubbles: true }));
    }
    function schritt() {
      if (einmal && jetzt === bilder.length - 1) { fertig = true; angehalten = true; halt(); return; }
      var warte = jetzt === bilder.length - 1 ? takt * 2 : takt;
      uhr = setTimeout(function () { zeige(jetzt + 1); schritt(); }, warte);
    }
    function lauf() {
      if (laeuft || angehalten || !sichtbar) return;
      laeuft = true; schritt(); knopfStand();
    }
    function halt() { laeuft = false; clearTimeout(uhr); knopfStand(); }
    function knopfStand() {
      knopf.setAttribute('aria-pressed', laeuft ? 'true' : 'false');
      knopf.setAttribute('aria-label', knopf.getAttribute(laeuft ? 'data-wort-an' : 'data-wort-aus'));
    }
    knopf.addEventListener('click', function () {
      if (laeuft) { angehalten = true; halt(); return; }
      if (fertig) { fertig = false; zeige(0); }
      angehalten = false; lauf();
    });

    wurzel.classList.add('oau--an');
    knopf.hidden = false;
    zeige(0);
    knopfStand();

    var beobachter = 'IntersectionObserver' in window ? new IntersectionObserver(function (e) {
      sichtbar = e[0].isIntersecting;
      if (sichtbar) lauf(); else halt();
    }, { threshold: 0.3 }) : null;
    if (beobachter) beobachter.observe(buehne); else { sichtbar = true; lauf(); }

    wurzel.__oau = {
      stopp: function () { halt(); if (beobachter) beobachter.disconnect(); },
      waehle: function (i) { angehalten = true; halt(); zeige(i); }
    };
  }

  function alle(ort) { (ort || document).querySelectorAll('[data-oau]').forEach(starte); }
  window.oneAufbau = {
    start: function (ort) { (ort || document).querySelectorAll('[data-oau]').forEach(function (w) { starte(w, true); }); },
    stopp: function (ort) { (ort || document).querySelectorAll('[data-oau]').forEach(function (w) { if (w.__oau) w.__oau.stopp(); }); }
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { alle(); });
  else alle();
  document.addEventListener('shopify:section:load', function (e) { alle(e.target); });
})();
